<template>
  <div>
    <!-- Floating Action Button -->
    <button @click="openSidebar" class="fab" :class="{ 'fab-hidden': isOpen }">
      <div class="image">
        <img src="@/assets/images/xavier-actions.png" style="height:1rem;width:unset;" :style="pollingDone && currentTabActions.length == 0 ? { 'filter': 'grayscale(1) opacity(0.4)' } : {}" />
      </div>
    </button>

    <!-- Overlay -->
    <div v-if="isOpen" class="overlay" @click="closeSidebar"></div>

    <!-- Slide-up Sidebar with Close Button -->
    <div class="sidebar" :class="{ 'sidebar-open': isOpen }">
      <div class="is-flex is-flex-direction-column sidebar-content">
        <div class="is-flex is-flex-direction-row">
          <div class="tabs is-medium is-flex-grow-5"
               style="--bulma-tabs-border-bottom-style:none;--bulma-link-text:purple;">
            <ul class="is-size-6">
              <li v-for="tab in tabs" @click="() => { selectedTab = tab }"
                  :class="{ 'is-active': selectedTab === tab }">
                <a :class="tab == 'hr' ? 'is-uppercase' : 'is-capitalized'">
                  {{ tab }}
                </a>
              </li>
            </ul>
          </div>
          <button class="close-btn" @click="closeSidebar">✕</button>
        </div>
        <div v-if="currentTabActions[selectedTab]" class="is-flex is-align-items-center">
          <div ref="prev-button" class="swiper-button-prev" @click="swiper.swiper.slidePrev()"
               :class="{ hidden: isSwiperBeginning }">
            <img src="@/assets/images/left-arrow-next-svgrepo-com.svg" style="">
          </div>
          <swiper-container ref="swiper" style="width:96%;" slides-per-view="4" navigation="true"
                            space-between="10" @swiperslidesupdated="onSwiperSlideChange" @swiperslidechange="onSwiperSlideChange">
            <swiper-slide v-for="item in currentTabActions[selectedTab]">
              <Action :action="item" @share-modal-opened="openShareModal" />
            </swiper-slide>
          </swiper-container>
          <div ref="next-button" class="image is-24x24 swiper-button-next" @click="swiper.swiper.slideNext()"
               :class="{ hidden: isSwiperEnd }">
            <img src="@/assets/images/right-arrow-next-svgrepo-com.svg"
                 style="filter: brightness(0) saturate(100%) invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg);cursor:pointer;">
          </div>
        </div>
        <div v-else-if="!pollingDone && !currentTabActions[selectedTab]" class="is-flex is-justify-content-space-around">
          <Spinner />
        </div>
        <div v-else class="is-flex is-justify-content-space-around" style="border: 1px dashed gray ;border-radius:1rem;">
          <p class="p-5 is-size-5">There are no actions for this category</p>
        </div>
      </div>
    </div>
  </div>
  <ShareModal v-if="isShareModalOpened" :service="selectedService" @closed="closeShareModal">
    <component :is="serviceComponent" :service="selectedService" @closed="closeShareModal" />
  </ShareModal>
</template>

<script setup>
import { inject, onBeforeMount, provide } from 'vue';
import { useTemplateRef } from 'vue';
import { onMounted } from 'vue';
import { ref } from 'vue';
import Action from './Action.vue';
import { computed } from 'vue';
import ShareModal from './ShareModal.vue';
import SlackModal from './SlackModal.vue';
import Spinner from '../Spinner.vue';
import TableModal from './TableModal.vue';
import InactiveModal from './InactiveModal.vue';
import { getItemId } from '@/utils/auth';
import { PollingManager } from '@/utils/ActionsPollingManager';

const props = defineProps(['presentationId', 'currentSlideNumber'])
const swiper = useTemplateRef('swiper');

const isOpen = ref(false);
const content = ref([]);
const isSwiperBeginning = ref(true);
const isSwiperEnd = ref(true);
const isShareModalOpened = ref(false);
const selectedService = ref(null);
const tabs = ['recommendations', 'strategy', 'management', 'marketing', 'sales', 'finance', 'hr'];
const selectedTab = ref('recommendations');
const pollingManager = ref(null);
const pollingDone = ref(false);

const ACTIONS_SERVE_API = import.meta.env.VITE_SERVE_ACTIONS_API;
const PARENT_APP_URL = import.meta.env.VITE_PARENT_APP_URL;

const userRef = inject('userRef');

provide('selectedTab', {
  selectedTab
});

onMounted(() => {
  isSwiperBeginning.value = true;
  isSwiperEnd.value = true;
  initialize();
});

async function initialize() {
  const url = ACTIONS_SERVE_API;

  pollingManager.value = new PollingManager(
    url,
    getItemId(props.presentationId),
    updateActions.bind(this),
    setPollingStatus.bind(this)
  );

  pollingManager.value.startPolling();
}

const updateActions = (fetchedData) => {
  content.value = JSON.parse(fetchedData.body).data;
}

const setPollingStatus = (pollingDoneStatus) => {
  pollingDone.value = pollingDoneStatus;
};

const currentTabActions = computed(() => {
  let currentContent = null;
  if (content.value != undefined && content.value.length > 0) {
    currentContent = content.value.filter((data) => props.currentSlideNumber  == data.slide_number)[0];
  }
  if (!currentContent) {
    closeSidebar()
    return [];
  }
  return currentContent.actions;
});

const serviceComponent = computed(() => {
  if (selectedService.value.connected) {
    if (selectedService.value.integration_type.toLowerCase() === 'slack') {
      return SlackModal;
    } else {
      return TableModal;
    }
  } else {
    return InactiveModal;
  }
});

const openSidebar = () => {
  isOpen.value = true;
};

const closeSidebar = () => {
  isOpen.value = false;
};

function onSwiperSlideChange() {
  isSwiperEnd.value = swiper.value?.swiper.isEnd;
  isSwiperBeginning.value = swiper.value?.swiper.isBeginning;
}

function openShareModal(service) {
  if (userRef.value.is_paid) {
    selectedService.value = service;
    isShareModalOpened.value = true;
  } else {
    parent.postMessage({
      "MessageId": "Unpaid_User_Action_Popup",
      "SendTime": Date.now(),
      "Values": {},
      "Origin": location.origin,
    }, PARENT_APP_URL);
  }
}

function closeShareModal() {
  selectedService.value = null;
  isShareModalOpened.value = false;
}

</script>

<style scoped>
 .fab {
   --base-offset: 190px;
   /* Fixed left offset */
   --right-adjust: 0px;
   /* Right sidebar adjustment */

   position: fixed;
   bottom: 0px;
   left: calc((var(--base-offset) + (100% - var(--right-adjust))) / 2);
   transform: translateX(-50%);
   /* width: 70px; */
   /* height: 80px; */
   border-top-left-radius: 20px;
   border-top-right-radius: 20px;
   background: white;
   color: black;
   border: none;
   cursor: pointer;
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: center;
   box-shadow: 0 4px 15px rgba(138, 43, 226, 0.3);
   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
   z-index: 31;
   padding: 18px;
   opacity: 1;
 }

 .fab-hidden {
   transform: translate(-50%, 100px);
   opacity: 0;
   pointer-events: none;
 }

 .close-btn {
   width: 50px;
   height: 50px;
   /* border-radius: 50%; */
   /* color: black; */
   font-size: 1.5rem;
   z-index: 32;
 }

 .close-btn:hover {
   transform: scale(1.1);
 }

 .sidebar {
   position: fixed;
   bottom: -400px;
   left: calc(5% + 190px);
   right: 5%;
   max-width: 1500px;
   /* width: 90%; */
   border-radius: 20px 20px 0 0;
   /* padding: 3px; */
   box-shadow: 0 -4px 15px rgba(0, 0, 0, 0.1);
   transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
   z-index: 30;
 }

 .sidebar-open {
   bottom: 0;
 }

 .sidebar-content {
   background: white;
   border-radius: 18px 18px 0 0;
   padding: 25px;
 }

 @media (max-width: 768px) {
   .fab {
     width: 60px;
     height: 70px;
     bottom: 30px;
   }

   .sidebar {
     width: 95%;
   }

   .close-btn {
     width: 45px;
     height: 45px;
     font-size: 1.3rem;
   }
 }

 swiper-container {
   width: 100%;
   max-width: 100%;
   max-height: 100vh;
   min-height: 0;
   min-width: 0;
 }

 swiper-container::part(button-prev) {
   display: none;
 }

 swiper-container::part(button-next) {
   display: none;
 }

 .swiper-button-prev,
 .swiper-button-next {
   width: 2%;
   cursor: pointer;
   transition: opacity 0.3s ease, visibility 0.3s ease;
   /* Smooth transition */
   filter: brightness(0) saturate(100%) invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg);
   cursor: pointer;
 }

 .swiper-button-prev {
   left: 0;
   /* Position left arrow outside the Swiper container */
 }

 .swiper-button-next {
   right: 0;
   /* Position right arrow outside the Swiper container */
 }

 .swiper-button-prev.hidden,
 .swiper-button-next.hidden {
   opacity: 0;
   /* Make the button transparent */
   visibility: hidden;
   /* Hide the button from the layout */
   pointer-events: none;
   /* Disable pointer events */
 }
</style>
